import React, {useEffect, useState} from "react";
import {SBL_BuilderPageMain} from "../interfaces";
import ProductRow from "./product-row";
import SelectedProductImg from "./selected-product-img";
import {cloneDeep} from "lodash";
import {GetProductIndex, IsProductInclude, OnProductClickChangeState} from "../services/logic-helper";
import { useAppDispatch, useAppSelector} from "../DAL/store";
import {MaxNumberOfChannelInputs} from "../local-enums";

/**
 * Product List
 */
interface IProductListProps {
    products : SBL_BuilderPageMain[],
    isMandatory:boolean
}
const CategoryProductList = (props:IProductListProps) => {

    const dispatch = useAppDispatch();
    const UserState_SystemType = useAppSelector((store) => store.UserState_SystemType);
    const UserState_SelectedProducts = useAppSelector((store) => store.UserState_SelectedProducts);
    const ProductList = useAppSelector((store) => store.ProductList);
    const SBL_BuilderPage = useAppSelector((store) => store.SBL_BuilderPage);
    const UserState_HiddenProductIds = useAppSelector((store) => store.UserState_HiddenProductIds);
    const UserState_NumberOfInputs = useAppSelector((store) => store.UserState_NumberOfInputs);

    const SelectedProducts = UserState_SelectedProducts.filter(prod => prod.categoryID === props.products[0].categoryID);

    const [lastSelectedProduct, setLastSelectedProduct] = useState({} as SBL_BuilderPageMain);
    const CurrentDisplayProducts = props.products.filter(prod => !UserState_HiddenProductIds.includes(prod.categoryProductID));
    //https://wavesaudio.atlassian.net/browse/DSWEB-1021

    const OnProductClick = (product : SBL_BuilderPageMain) => {


        let updatedArray = cloneDeep(SelectedProducts);

        if(product.selectType === "multi"){
            if(IsProductInclude(product,updatedArray)){
                let itemIndex = GetProductIndex(product,updatedArray);
                if (itemIndex !== -1) {
                    updatedArray.splice(itemIndex, 1);
                    if(updatedArray.length > 0){
                        setLastSelectedProduct(updatedArray[0]);
                    }else{
                        setLastSelectedProduct({} as SBL_BuilderPageMain);
                    }
                }
            }else{
                //block action if NumberOfInput is not valid
                //https://wavesaudio.atlassian.net/browse/DSWEB-1021
                if(UserState_NumberOfInputs + (product.numberOfInputs * product.quantity) > MaxNumberOfChannelInputs) return;

                updatedArray.push(product);
                setLastSelectedProduct(product);
            }

        }else{
            if(SelectedProducts.length > 0 && product.categoryProductID === lastSelectedProduct.categoryProductID && !props.isMandatory){
                //if category type is optional && input type is radio buttons (single select ) un selected the product.
                updatedArray=[];
                setLastSelectedProduct({} as SBL_BuilderPageMain);
            }else{
                updatedArray = [product];
                setLastSelectedProduct(product);
            }

        }


        OnProductClickChangeState(updatedArray,
            product.categoryID,
            UserState_SystemType,
            UserState_SelectedProducts,
            SBL_BuilderPage.sbl_BuilderPageProduct_ProductList,
            ProductList,
            SBL_BuilderPage,
            dispatch);
        return false;
    }

    useEffect(() => {
        if(SelectedProducts.length > 0){
            setLastSelectedProduct(SelectedProducts[0]);
        }

    }, [SelectedProducts]);
    return (
        <div className="w-full mt-2">
            {props.products.length > 1 &&
                <>
                    {props.products[0].selectType === "multi" ?
                        <div className="font-bold pb-2">You can select multiple options:</div>
                        :
                        <div className="font-bold pb-2">You can select 1 of the options below:</div>

                    }
                </>
            }
            <ul>
                {CurrentDisplayProducts.map((product, i) => {
                    return (<li key={i}>
                            <ProductRow product={product}
                                        onProductClick={OnProductClick}
                                        selectedProducts={SelectedProducts}
                                        isLastRow={i === CurrentDisplayProducts.length -1} />
                        </li>
                    )
                })}
            </ul>

            {lastSelectedProduct && SelectedProducts.length > 0 && <SelectedProductImg relativePath={lastSelectedProduct.thumb} />}

        </div>
    );
};

export default CategoryProductList;
